import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router'

import { TertiaryButton } from '@enechain/ecloud-designsystem'
import { FaCircleXmarkSolid } from '@enechain/ecloud-icons'

import {
  EMPTY_PANEL_ICON_SIZE,
  EmptyPanel,
} from '~/components/common/EmptyPanel'
import { routePaths } from '~/routes/routePaths'

/**
 * workflowId のワークフローが見つからない時に、画面本体の代わりに置く表示
 * (spec AC-WFW-040)。業務ワークフローの遷移先画面とワークフロー詳細画面で共通。
 *
 * 本体ごと差し替えるので、編集・確定操作も日付操作 UI も対象日に依存するデータも
 * 描画されない (= AC-WFW-040 の読み取り専用・日付操作の非活性・データ非表示を
 * まとめて満たす)。戻る導線は本 component のボタンが担い、WorkflowBackBar は
 * 出さない。見た目は design `design/demand/case-detail.html` の not-found 表示。
 */
export const WorkflowNotFoundView = (): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <EmptyPanel
      action={
        /* 遷移なので button ではなく link で描く (中クリック・新規タブを潰さない)。 */
        <TertiaryButton asChild>
          <RouterLink to={routePaths.workflowCases.path}>
            {t('common:workflowNotFound.backToList')}
          </RouterLink>
        </TertiaryButton>
      }
      description={t('common:workflowNotFound.description')}
      icon={
        <FaCircleXmarkSolid
          boxSize={EMPTY_PANEL_ICON_SIZE}
          aria-hidden="true"
        />
      }
      title={t('common:workflowNotFound.title')}
    />
  )
}
